export function formatDuration(seconds) {
    if (seconds == null || Number.isNaN(Number(seconds))) return "—";

    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    if (mins === 0) return `${secs} san`;
    if (secs === 0) return `${mins} dəq`;
    return `${mins} dəq ${secs} san`;
}

export function truncate(str, length) {
    if (str == null) return "";
    return str.length > length ? str.slice(0, length) + '...' : str;
}